import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles(theme => ({
  root: {
    alignContent: 'center',
    marginTop: theme.spacing(2)
  }
}))
